import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Flex } from '@chakra-ui/react';

import OptionsSection from '../OptionsSection';

import { fetchGroups } from '../utils/fetchGroups';
import { sendRequest } from '../utils/sendRequest';

import { IText } from '~/components/UI/Inputs';
import { Button, Spinner } from '~/components/ChakraComponents';

export default function EditGroupModal({ group, onClose }) {
  const [loading, setLoading] = useState(true);

  const [name, setName] = useState(group.name);
  const [users, setUsers] = useState([]);
  const [hospitals, setHospitals] = useState([]);

  useEffect(() => {
    fetchGroups(responses => {
      setUsers(responses[0].data.data);
      setHospitals(responses[1].data.data);

      setLoading(false);
    }, group);
  }, []);

  const onEdit = () => {
    if (name.length < 3) {
      return toast.error('Por favor digite um nome do grupo válido.');
    }

    sendRequest(
      `/contractors/permissionsgroup/${group.id}`,
      'patch',
      'Grupo editado com sucesso!',
      [name, users, hospitals]
    );
  };

  return (
    <Flex flexDir="column" w="700px" mw="95px" h="85vh">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Flex
            flexDir="column"
            h="100%"
            px={2}
            overflowY="auto"
            overflowX="hidden"
          >
            <IText
              label="nome do grupo"
              placeholder="Ex: Diretor"
              maxLength="64"
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <OptionsSection
              title="Usuários"
              description="Usuários do sistema que fazem parte desse grupo"
              items={users}
              setItems={setUsers}
            />
            <OptionsSection
              title="Hospitais"
              description="Hospitais que os usuários do grupo poderão acessar"
              items={hospitals}
              setItems={setHospitals}
            />
          </Flex>
          <Flex mt={3} justifyContent="space-evenly">
            <Button title="cancelar" variant="secondary" onClick={onClose} />
            <Button title="editar" variant="success" onClick={onEdit} />
          </Flex>
        </>
      )}
    </Flex>
  );
}
